import { useEffect, useState } from 'react';
import { Text, View } from 'react-native';

import { connectionBannerState } from '@/lib/net/connection-banner';
import { isServerUnreachable, subscribeServerReachability } from '@/lib/net/net-status';

function browserOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}

/**
 * Sits at the top of the sidebar and tells the user when edits cannot reach the
 * server. Hidden while the last request or live connection succeeded.
 */
export function ConnectionBanner() {
  const [online, setOnline] = useState(browserOnline);
  const [unreachable, setUnreachable] = useState(isServerUnreachable);

  useEffect(() => {
    const update = () => setOnline(browserOnline());
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    const unsubscribe = subscribeServerReachability(setUnreachable);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
      unsubscribe();
    };
  }, []);

  const state = connectionBannerState({ browserOnline: online, serverUnreachable: unreachable });
  if (!state) {
    return null;
  }
  return (
    <View className="border-b border-warning bg-warning-muted px-1.5 py-1">
      <View className="flex-row items-center gap-1">
        <View className="h-1.5 w-1.5 rounded-full bg-warning" />
        <Text className="text-[11px] font-semibold text-fg">{state.title}</Text>
      </View>
      <Text className="mt-0.5 text-[10px] leading-snug text-fg-muted">{state.detail}</Text>
    </View>
  );
}
